module.exports = __webpack_public_path__ + "img/grey-7days.fff2d21d.png";